import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'sf-authentication',
	templateUrl: './authentication.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticationComponent {}
